enum RolesEnum {
    Agent = 'Agent',
    Applicant = 'Applicant',
    ClientCSR = 'Client CSR',
    ClientSupervisor = 'Client Supervisor',
    Processor = 'Processor',
    PNProcessor = 'Preneed Processor',
    TIRepresentative = 'TI Representative',
    Underwriter = 'Underwriter',
    RgaUnderwriter = 'RGA Underwriter',
    CSR = 'CSR',
    Supervisor = 'Supervisor',
    AmFamConversion = 'AmFam Conversion',
    AmFamFlexConversion = 'AmFam Flex Conversion'
}

export { RolesEnum };
